module.exports = "/images/az.svg";